const estado = {
  pt: ['Não alocada', 'Programada', 'Em espera', 'Ao vivo', 'Encerrada'],
  en: ['Unallocated', 'Scheduled', 'On hold', 'Live', 'Closed'],
}

export default estado;